import React from 'react';
import OrderRequestForm from '../../components/order/OrderRequestForm';

export default function NewOrderPage() {
  return <OrderRequestForm />;
}
